import React from 'react'
import PropTypes from 'prop-types'

import { Checkbox } from 't3-widgets'

import styles from './checklist-item.module.css'

const Item = ({
    onChange = () => console.warn('onChange'),
    children = 'Item description',
    header = 'Header',
    checked = false,
    disabled = false
}) => {
    const handleChange = disabled ? null : onChange

    return (
        <div onClick={handleChange} className={styles.container}>
            <div className={styles['radio-container']}>
                <Checkbox onChange={handleChange} disabled={disabled} checked={checked} />
            </div>
            <div className={styles['text-container']}>
                <div>
                    <h2>{header}</h2>
                </div>
                <div>{children}</div>
            </div>
        </div>
    )
}

Item.propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    header: PropTypes.string,
    children: PropTypes.string,
    onChange: PropTypes.func
}

export { Item }
